var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.localValue.color ? _vm.localValue.color : _vm.color,"size":_vm.size}},[(!!_vm.localValue.avatar)?_c('v-img',{attrs:{"src":_vm.avatarLocal}}):_c('div',{style:({
      'color': _vm.localValue.textColor ? _vm.localValue.textColor : 'black'
    })},[_vm._v(" "+_vm._s(_vm.initials)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }